export const buttonContainer = {
  color: '#C0C0C0',
  fontSize: '16px',
  textTransform: 'none',
  height: '46px',
  display: 'flex',
  alignItems: 'center',
  textAlign: 'left',
  borderRadius: '6px',
  marginX: 'auto',
  paddingX: '16px',
  gap: '10px',
};
